import React from 'react'

interface Props {
    image: string
    title?: string
    description?: string
    textButton?: string
    onClick?: () => void
}

const ImageEmptyList = ({
    image,
    title,
    description,
    textButton,
    onClick,
}: Props) => {
    const isNonEmptyString = (value: unknown): value is string =>
        typeof value === 'string' && value.trim() !== ''

    return (
        <div className="flex flex-col items-center justify-center text-center px-4 py-8">
            {isNonEmptyString(image) && (
                <img
                    src={image}
                    alt="Empty Image"
                    className="mb-6"
                />
            )}

            {isNonEmptyString(title) && (
                <h2 className="text-base font-semibold text-[#3E5060] mb-2">
                    {title}
                </h2>
            )}

            {isNonEmptyString(description) && (
                <p className="text-sm font-normal text-[#3E5060] mb-4 max-w-xs">
                    {description}
                </p>
            )}

            {isNonEmptyString(textButton) && typeof onClick === 'function' && (
                <button
                    onClick={onClick}
                    className="bg-[#568C13] text-white text-sm font-medium px-5 py-2.5 rounded-md"
                >
                    {textButton}
                </button>
            )}
        </div>
    )
}

export default ImageEmptyList
